import * as React from 'react';
import { OverlayTrigger, Tooltip, Table } from 'react-bootstrap';
import './bloodwork-ref-range-analysis.css';
import { ReferenceRangeChart } from '../charts/ReferenceRangeChart';
import { EGFRReferenceRangeChart } from '../charts/EGFRReferenceRangeChart';
import { Bloodwork, Section, PanelMarker, MenstrualPhase } from '../../models';
import { RDWReferenceRangeChart } from '../charts/RDWReferenceRangeChart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  title: string;
  section: Section;
  bloodwork: Bloodwork;
  panelMarkers: PanelMarker[];
  infoLink: string;
};

type State = {
  showRefRangeModal: boolean;
};

export class ReferenceRangeAnalysis extends React.Component<Props, {}> {
  state: State = {
    showRefRangeModal: false,
  };

  showRefRangeModal = () => {
    const { infoLink } = this.props;
    if (infoLink) {
      window.open(infoLink);
    } else {
      this.setState({
        showRefRangeModal: true,
      });
    }
  };

  onHideRefRangeModal = () => {
    this.setState({
      showRefRangeModal: false,
    });
  };

  labCorpInfoTooltip = (panelMarker: PanelMarker) => {
    // tslint:disable-next-line:max-line-length
    const labCorpInfoTooltip =
      'Click this icon to learn more about how the reference ranges for this marker were determined.';
    return <Tooltip id="modal-tooltip">{labCorpInfoTooltip}</Tooltip>;
  };

  displayChart(panelMarker: PanelMarker, index: number) {
    console.log({ eGFR: panelMarker });
    let chart = (
      <ReferenceRangeChart
        panelMarker={panelMarker}
        chartContainerClass="reference-range-chart-container"
        showPlotBandLabels={index === 1}
      />
    );
    if (panelMarker.isEGFR() || panelMarker.field.useEGFRChart) {
      chart = (
        <EGFRReferenceRangeChart
          panelMarker={panelMarker}
          chartContainerClass="reference-range-chart-container"
        />
      );
    } else if (panelMarker.field.useRDWChart) {
      chart = (
        <RDWReferenceRangeChart
          panelMarker={panelMarker}
          chartContainerClass="reference-range-chart-container"
        />
      );
    }
    return chart;
  }

  openWindow(pm?: PanelMarker) {
    if (pm) {
      window.open(pm.field.labCorpLink);
    } else if (this.props.infoLink) {
      window.open(this.props.infoLink);
    }
  }

  showChart(index: number): string {
    return index === 0 ? 'none' : 'block';
  }

  menstrualPhase() {
    const { section, bloodwork } = this.props;
    if (section === Section.SEX_HORMONE) {
      const menstrualPhase = bloodwork.menstrualPhase;
      if (menstrualPhase) {
        return (
          <div>
            <span style={{ marginLeft: '20px', fontWeight: 'bold' }}>
              Menstrual Phase
            </span>
            <span style={{ marginLeft: '8px' }}>
              {menstrualPhase === MenstrualPhase.NONE
                ? `${MenstrualPhase.NONE} (children's ranges)`
                : menstrualPhase}
            </span>
          </div>
        );
      }
    }
    return null;
  }

  render() {
    const { panelMarkers } = this.props;
    if (!panelMarkers || panelMarkers.length === 0) {
      return null;
    }

    // This is a hack because the blood drop on the first blood drop is always misaligned.
    // We take the first marker and place it at the beginning of the array and then
    // we don't display it.
    const fakePanelMarker: PanelMarker = panelMarkers[0];
    panelMarkers.unshift(fakePanelMarker);

    return (
      <div>
        {this.menstrualPhase()}
        <Table className="labsmartz-chart-table">
          <tbody>
            {panelMarkers.map((pm: PanelMarker, index: number) => {
              return (
                <tr key={index} style={{ display: this.showChart(index) }}>
                  <td className="text-nowrap ref-range-category">
                    {pm.field.getChartLabel()}&nbsp;&nbsp;
                    {pm.field.labCorpLink ? (
                      <OverlayTrigger overlay={this.labCorpInfoTooltip(pm)}>
                        <FontAwesomeIcon
                          icon="external-link-alt"
                          onClick={() => {
                            this.openWindow(pm);
                          }}
                        />
                      </OverlayTrigger>
                    ) : null}
                    <br />
                    <span className="ref-range-category-value">
                      {pm.displayValue()} {pm.field.getChartUnits()}
                    </span>
                  </td>
                  <td>{this.displayChart(pm, index)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}
